// /**
//  * AES-GCM + RSA-OAEP Hybrid Decryption (matches backend)
//  */
// import {
//   cryptoLog,
//   convertBase64ToBytes,
//   importRsaPrivateKey,
// } from "./keyUtils.js";

// const privateKeyPem = process.env.REACT_APP_PRIVATE_KEY;

// export async function hybridDecrypt(encryptedObj) {
//   // cryptoLog("hybridDecrypt:start");

//   try {
//     if (!privateKeyPem) throw new Error("Private key missing.");
//     if (
//       !encryptedObj?.encrypted_key ||
//       !encryptedObj?.iv ||
//       !encryptedObj?.ciphertext ||
//       !encryptedObj?.tag
//     ) {
//       throw new Error("Invalid encrypted object: missing fields.");
//     }

//     // 1️⃣ Import RSA private key
//     const privateKey = await importRsaPrivateKey(privateKeyPem);

//     // 2️⃣ Decrypt AES key using RSA-OAEP(SHA-256)
//     const aesKeyRaw = await window.crypto.subtle.decrypt(
//       { name: "RSA-OAEP" },
//       privateKey,
//       convertBase64ToBytes(encryptedObj.encrypted_key)
//     );

//     // 3️⃣ Import AES key for AES-GCM
//     const aesKey = await window.crypto.subtle.importKey(
//       "raw",
//       aesKeyRaw,
//       { name: "AES-GCM" },
//       false,
//       ["decrypt"]
//     );

//     // 4️⃣ Combine ciphertext + tag for GCM decryption
//     const iv = convertBase64ToBytes(encryptedObj.iv);
//     const ciphertext = convertBase64ToBytes(encryptedObj.ciphertext);
//     const tag = convertBase64ToBytes(encryptedObj.tag);

//     // In WebCrypto, tag must be appended to ciphertext
//     const combined = new Uint8Array(ciphertext.length + tag.length);
//     combined.set(ciphertext);
//     combined.set(tag, ciphertext.length);

//     // 5️⃣ AES-GCM decrypt
//     const decrypted = await window.crypto.subtle.decrypt(
//       { name: "AES-GCM", iv },
//       aesKey,
//       combined
//     );

//     // 6️⃣ Decode JSON
//     const decoded = new TextDecoder().decode(decrypted);
//     const result = JSON.parse(decoded);

//     // cryptoLog("hybridDecrypt:success");
//     return result;
//   } catch (err) {
//     cryptoLog("hybridDecrypt:error", err.message, "error");
//     throw new Error("Hybrid decryption failed: " + err.message);
//   }
// }

















/**
 * AES-GCM + RSA-OAEP Hybrid Decryption (matches backend)
 */
import {
  cryptoLog,
  convertBase64ToBytes,
  importRsaPrivateKey,
} from "./keyUtils.js";

const privateKeyPem = process.env.REACT_APP_PRIVATE_KEY;

export async function hybridDecrypt(response) {
  // cryptoLog("hybridDecrypt:start");
  const encryptedObj=response["data"]

  try {
    if (!privateKeyPem) throw new Error("Private key missing.");
    if (
      !encryptedObj?.encrypted_key ||
      !encryptedObj?.iv ||
      !encryptedObj?.ciphertext ||
      !encryptedObj?.tag
    ) {
      throw new Error("Invalid encrypted object: missing fields.");
    }

    // 1️⃣ Import RSA private key
    const privateKey = await importRsaPrivateKey(privateKeyPem);

    // 2️⃣ Decrypt AES key using RSA-OAEP(SHA-256)
    const aesKeyRaw = await window.crypto.subtle.decrypt(
      { name: "RSA-OAEP" },
      privateKey,
      convertBase64ToBytes(encryptedObj.encrypted_key)
    );

    // 3️⃣ Import AES key for AES-GCM
    const aesKey = await window.crypto.subtle.importKey(
      "raw",
      aesKeyRaw,
      { name: "AES-GCM" },
      false,
      ["decrypt"]
    );

    // 4️⃣ Combine ciphertext + tag for GCM decryption
    const iv = convertBase64ToBytes(encryptedObj.iv);
    const ciphertext = convertBase64ToBytes(encryptedObj.ciphertext);
    const tag = convertBase64ToBytes(encryptedObj.tag);

    // In WebCrypto, tag must be appended to ciphertext
    const combined = new Uint8Array(ciphertext.length + tag.length);
    combined.set(ciphertext);
    combined.set(tag, ciphertext.length);

    // 5️⃣ AES-GCM decrypt
    const decrypted = await window.crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      aesKey,
      combined
    );

    // 6️⃣ Decode JSON
    const decoded = new TextDecoder().decode(decrypted);
    const result = JSON.parse(decoded);

    // cryptoLog("hybridDecrypt:success");
    response["data"]=result
    return response;
  } catch (err) {
    cryptoLog("hybridDecrypt:error", err.message, "error");
    throw new Error("Hybrid decryption failed: " + err.message);
  }
}
